import { configureStore } from '@reduxjs/toolkit'

// Import RTK slices
import authenticateReducer from './slices/authenticateSlice'
import userReducer from './slices/userSlice'
import layoutReducer from './slices/layoutSlice'
import formDataReducer from './slices/formDataSlice'
import appDataReducer from './slices/appDataSlice'
import modalReducer from './slices/modalSlice'
import debugReducer from './slices/debugSlice'

// Define RootState interface
export interface RootState {
  authenticate: ReturnType<typeof authenticateReducer>
  user: ReturnType<typeof userReducer>
  layout: ReturnType<typeof layoutReducer>
  formData: ReturnType<typeof formDataReducer>
  appData: ReturnType<typeof appDataReducer>
  modal: ReturnType<typeof modalReducer>
  debug: ReturnType<typeof debugReducer>
}

// Create store configuration
export const createAppStore = (localStorer: any) => configureStore({
  reducer: {
    authenticate: authenticateReducer,
    user: userReducer,
    layout: layoutReducer,
    formData: formDataReducer,
    appData: appDataReducer,
    modal: modalReducer,
    debug: debugReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types for serialization checks
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE', 'debug/addDebugLog'],
        // Ignore these paths in the state
        ignoredPaths: ['debug.logs'],
      },
    }).concat(localStorer),
  devTools: import.meta.env.DEV,
})

// Export types
export type AppStore = ReturnType<typeof createAppStore>
export type AppDispatch = AppStore['dispatch']

// Legacy exports for backwards compatibility
export * from './actions'
export { default as rootReducer } from './reducers'